import { type EmployeeWithFlexflowTransactions } from 'src/shared/types/flexflowTransactions';

type FlexflowFeatureSettings = {
  frWalletEnabled?: boolean;
  frWalletDisabledAt?: string | null;
  sbEnabled?: boolean;
  sbDisabledAt?: string | null;
};

export const checkIfFrWalletWasEverEnabled = (flexflowSettings?: FlexflowFeatureSettings | null): boolean =>
  Boolean(flexflowSettings?.frWalletEnabled) || Boolean(flexflowSettings?.frWalletDisabledAt);

export const checkIfSbWasEverEnabled = (flexflowSettings?: FlexflowFeatureSettings | null): boolean =>
  Boolean(flexflowSettings?.sbEnabled) || Boolean(flexflowSettings?.sbDisabledAt);

export const getFlexflowTransactionCount = (row: EmployeeWithFlexflowTransactions) =>
  (row.frTransactions?.totalTransactions ?? 0) + (row.sbTransactions?.totalTransactions ?? 0);

export const getFlexflowTotalAmount = (row: EmployeeWithFlexflowTransactions) =>
  (row.frTransactions?.totalAmount ?? 0) + (row.sbTransactions?.totalAmount ?? 0);
